import { Component, OnInit } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import { BaseModal, GroupCriterion, ListItem } from '../../shared'

@Component({
    templateUrl: './group-criteria.component.html',
    standalone: true,
    imports: [FormsModule, WjInputModule, FaIconComponent],
})
export class GroupCriteriaComponent extends BaseModal implements OnInit {
    faSpinner = faSpinner
    isAdding = true
    target!: GroupCriterion
    criteriaTypes = [
        new ListItem('prDept', 'PR Dept'),
        new ListItem('prGroups', 'PR Group'),
        new ListItem('classes', 'Class'),
        new ListItem('earnCodes', 'Earn Code'),
        new ListItem('positionCodes', 'Position Code'),
    ]

    operatorMap = [new ListItem('==', 'Include'), new ListItem('!=', 'Exclude')]

    criteriaValues: ListItem<string>[] = []
    criteriaData!: any

    get title() {
        return this.isAdding ? 'Add Condition' : 'Edit Condition'
    }

    ngOnInit() {
        if (this.isAdding) {
            this.target.operator = '=='
            this.target.attributeName = this.criteriaTypes[0].value
        }

        this.onTypeChange()
    }

    protected onBeforeSave() {
        if (!this.target.attributeValue) this.target.attributeValue = this.criteriaValues[0].value
        this.target.attributeValueName = this.criteriaValues.find(x => x.value === this.target.attributeValue)?.display || ''
        return super.onBeforeSave()
    }

    onTypeChange() {
        const values = this.criteriaData[this.target.attributeName]
        if (values) {
            this.criteriaValues = values.map(x => new ListItem(x.key, x.value))
        }
    }
}
